import axios from 'axios';
import { AccountStore } from '@/store/account';

export function setupAxios(context) {
  axios.defaults.withCredentials = true;

  axios.interceptors.request.use(
    async (request: any) => {
      context.$Progress.start();

      request.headers.Authorization = `Bearer ${localStorage.getItem('_token')}`;

      return request;
    },
    (err) => {
      return Promise.reject(err);
    }
  );

  axios.interceptors.response.use(
    (response: any) => {
      context.$Progress.finish();

      return response;
    },

    async (error) => {
      const originalConfig = error.config;
      if (originalConfig.url !== '/auth/login' && error.response) {
        if (error.response.status === 401) {
          if (!originalConfig._retry || originalConfig._retry < 3) {
            if (!originalConfig._retry) {
              originalConfig._retry = 0;
            }
            originalConfig._retry++;

            await AccountStore.refresh();
            return axios(error.config);
          } else {
            AccountStore.logout();
            AccountStore.loginWithReturnUrl();
          }
        } else {
          console.log(error);
        }
      }

      return Promise.reject(error);
    }
  );
}
